var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_33429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3588 11.5626C12.3978 11.5626 11.9358 12.0834 10.3588 12.0834C8.78176 12.0834 8.32305 11.5626 7.35876 11.5626C4.87439 11.5626 2.85876 13.5222 2.85876 15.9376V16.7709C2.85876 17.6335 3.57863 18.3334 4.46591 18.3334H16.2516C17.1389 18.3334 17.8588 17.6335 17.8588 16.7709V15.9376C17.8588 13.5222 15.8431 11.5626 13.3588 11.5626ZM16.2516 16.7709H4.46591V15.9376C4.46591 14.3881 5.76501 13.1251 7.35876 13.1251C7.8476 13.1251 8.64113 13.6459 10.3588 13.6459C12.0898 13.6459 12.8666 13.1251 13.3588 13.1251C14.9525 13.1251 16.2516 14.3881 16.2516 15.9376V16.7709ZM10.3588 11.0417C13.0206 11.0417 15.1802 8.94214 15.1802 6.35425C15.1802 3.76636 13.0206 1.66675 10.3588 1.66675C7.69693 1.66675 5.53734 3.76636 5.53734 6.35425C5.53734 8.94214 7.69693 11.0417 10.3588 11.0417ZM10.3588 3.22925C12.13 3.22925 13.573 4.63224 13.573 6.35425C13.573 8.07625 12.13 9.47925 10.3588 9.47925C8.58756 9.47925 7.14448 8.07625 7.14448 6.35425C7.14448 4.63224 8.58756 3.22925 10.3588 3.22925Z",
    fill: "#BBBBF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_33429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16.6667,
    fill: "white",
    transform: "translate(2.85876 1.66675)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.f66af6d03221a3ee88c9f2e87515d22c.svg";
export { ForwardRef as ReactComponent };